export function HeroSection() {
  return (
    <section
      className="text-center"
      style={{ fontFamily: "var(--homepage-sans-stack)" }}
    >
      <div className="px-6 pt-6 pb-0 sm:pt-10">
        <h1
          className="mb-2 font-semibold text-[1.6rem] text-[var(--explore-text-primary)] leading-tight sm:text-[2.5rem]"
          style={{ fontFamily: "var(--explore-card-title-stack)" }}
        >
          Explore what&apos;s new in AI
        </h1>
        <p className="mb-0 text-[0.85rem] text-[var(--explore-text-secondary)] sm:text-base">
          <strong className="font-semibold text-[var(--explore-text-primary)]">
            Where people deep in AI
          </strong>{" "}
          come to stay current.
        </p>
      </div>
    </section>
  );
}
